import axios from 'axios';

/**
 * POST /switches/send-command/bulk. The UI sends only EBP here.
 * @param {string[]} deviceIds
 * @param {{EBP: number}} data  0 = reactivate, non-zero = block
 * @returns {Promise<*>}  full `response.data`
 */

export const bulkUpdateSwitchDeviceService = async (deviceIds, data) => {
  const response = await axios.post('/switches/send-command/bulk', {
    deviceIds,
    ...data,
  });
  return response.data;
};

/**
 * POST /blowers/send-command/bulk. The UI sends only EBP here.
 * @param {string[]} deviceIds
 * @param {'TGS'|'TES'} deviceType
 * @param {{EBP: number}} data  0 = reactivate, non-zero = block
 * @returns {Promise<*>}  full `response.data`
 */

export const bulkUpdateBlowerDeviceService = async (deviceIds, deviceType, data) => {
  const response = await axios.post('/blowers/send-command/bulk', {
    deviceIds,
    deviceType,
    ...data,
  });
  return response.data;
};
